import { StoryblokComponent } from 'gatsby-source-storyblok';
import React, { memo } from 'react';
import { Blok } from '../../../interfaces/Blok.interface';
import { FormFieldBlokProps } from '../../FormFields/FormFieldBlokProps.interface';
import { FormFieldRowBlokProps } from '../../FormFields/FormFieldRow/FormFieldRow';
import { useFormikContext } from 'formik';
import { InitialValueProps } from '../../QuoteForm/QuoteFormProps';

interface FormSectionProps {
  heading: string;
  description: string;
  formFields: (FormFieldBlokProps | FormFieldRowBlokProps)[];
  sectionNumber: number;
}

const FormSection: React.FC<FormSectionProps> = ({
  heading,
  description,
  formFields,
  sectionNumber,
}) => {
  const { setFieldValue, errors, values } =
    useFormikContext<InitialValueProps>();

  const conditionalFields = ['static_form_checkbox'];
  const isConditionalField = Boolean(
    formFields.find((field) => conditionalFields.includes(field.component))
  );

  const filteredFormFields = formFields.filter((field) => {
    if (!isConditionalField) return true;
    if (conditionalFields.includes(field.component)) return true;
    if ('key' in field && field.key === 'buy-address') return true;

    if (
      formFields.find((field) => field.component === 'static_form_checkbox')
    ) {
      const isCheckboxSelected =
        values?.isRemortgageAddressSameAsCustomerAddress ||
        values?.isSellAddressSameAsCustomerAddress;
      return !isCheckboxSelected;
    }
    return true;
  });

  return (
    <section className="mx-3.5 py-12 border-b border-b-border/default sm:mx-0">
      <div className="space-y-6">
        <div className="flex items-center justify-start text-2xl gap-x-4">
          <div className="w-9 h-9 rounded-full bg-icon/icon-active-bg flex items-center justify-center">
            <p className="text-system/white font-dm-serif-display">
              {sectionNumber}
            </p>
          </div>
          <div className="text-text/body">
            <p className="font-dm-serif-display">{heading}</p>
            {description && <p className="text-sm">{description}</p>}
          </div>
        </div>
        <div className="space-y-12">
          {filteredFormFields.map((formField: Blok) => (
            <StoryblokComponent blok={{ ...formField }} key={formField._uid} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default memo(FormSection);
